import { env } from 'admin/lib/config/env-config.js'

export const RECORD = {
  VIEW: `${env.NX_PORTAL_URL}/accounts/:accountId/projects/:projectId/:moduleName/record/:recordId`,
  EDIT: `${env.NX_PORTAL_URL}/accounts/:accountId/projects/:projectId/:moduleName/record/:recordId/edit`
}
